export default {
  actionButton: 'tag-list-action',
  toggleMoreButton: 'tag-list-toggle-more',
};
